const { VITE_SENTRY_URL, VITE_BACKEND_API_URL, VITE_RAG_URL } = import.meta.env;

/**
 * Environment configuration
 *
 * VITE_BACKEND_API_URL: Main backend API URL
 * VITE_RAG_URL: RAG (Retrieval-Augmented Generation) service URL
 *   - May be on a different domain than the main backend
 *   - Used for RAG-specific endpoints
 */
export const webConfig: {
  VITE_SENTRY_URL: string | undefined;
  VITE_BACKEND_API_URL: string | undefined;
  VITE_RAG_URL: string | undefined;
} = {
  VITE_SENTRY_URL,
  VITE_BACKEND_API_URL,
  VITE_RAG_URL,
};

/**
 * Gets the appropriate base path for VAD assets based on environment
 */
export const getBasePath = (): string => {
  const { origin } = window.location;
  // Ensure there's a trailing slash
  return origin.endsWith("/") ? origin : `${origin}/`;
};

/**
 * Gets the appropriate stream player worklet URL based on environment
 * This handles dynamic BASE_URL for production deployments
 */
export const getWorkletURL = (url: string): string => `${getBasePath()}${url}`;
